import { Channel, getChannelsFromPypes } from './get-channels-from-pypes';
import { getCustomerPypes } from './get-customer-pypes';

/**
 * All channels (widget + voice streams) across a project's pypes, both envs —
 * used by the Data Privacy page to show which channels use each rule set.
 */
export const getProjectChannels = async ({
  uniqueCustomerId,
  projectId,
}: {
  uniqueCustomerId: string;
  projectId: string;
}): Promise<Channel[]> => {
  const { live, sandbox } = await getCustomerPypes({
    uniqueCustomerId,
    projectId,
  });

  return getChannelsFromPypes([...(live ?? []), ...(sandbox ?? [])]);
};
